var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,[React.createElement("mask",{"id":"mask0_987_150338","style":{"maskType":"alpha"},"maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"24","height":"25","key":0},React.createElement("rect",{"y":"0.507812","width":"24","height":"24"})),React.createElement("g",{"mask":"url(#mask0_987_150338)","key":1},[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11 22.5078V2.50781H13V22.5078H11Z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2 11.5078H22V13.5078H2V11.5078Z","key":1})])]);
}

Plus.defaultProps = {"width":"24","height":"25","viewBox":"0 0 24 25","fill":"none"};

module.exports = Plus;

Plus.default = Plus;
